import moment from 'moment'
import { toast } from 'react-toastify'
import { createNewPatientEvent, overridePatientEvent } from '../../../../../../helper/fusionHelper'

/**
 * We need to look at the patientEvent that precedes this encounter
 * to know if this visit is the first after a discharge or not
 */
export function visitFollowsDischarge(service_date_from, patientEventHistory) {
  let currentDate = moment.utc(service_date_from).toISOString()
  let lowToHighEvents = [...patientEventHistory]
    .filter((event) => event.type === 'ADMIT' || event.type === 'DISCHARGE')
    .sort((a, b) => {
      const ssDiff = new Date(a.service_date_from) - new Date(b.service_date_from)
      if (ssDiff !== 0) {
        return ssDiff
      }

      const dateDiff = new Date(a.date) - new Date(b.date)
      if (dateDiff !== 0) {
        return dateDiff
      }

      return a.type.localeCompare(b.type)
    })
  const eventsLength = lowToHighEvents.length

  if (eventsLength === 0) {
    return false
  }

  // const previousChargeIds = {}
  for (let i = 0; i < eventsLength; i++) {
    if (currentDate <= moment.utc(lowToHighEvents[i].date).toISOString() && i > 0) {
      return (
        lowToHighEvents[i - 1].type === 'DISCHARGE'
        // &&
        // // make sure the event's charge id is indeed before the discharge
        // previousChargeIds[lowToHighEvents[i]?.charge_id]
      )
    }

    // taking out because i forgot why this is here and we do a better sort now
    // if (lowToHighEvents[i]?.charge_id) {
    //   previousChargeIds[lowToHighEvents[i]?.charge_id] = lowToHighEvents[i]?.charge_id
    // }
  }

  //check one element array OR last element for an edge case
  if (currentDate > moment.utc(lowToHighEvents[eventsLength - 1].date).toISOString()) {
    return lowToHighEvents[eventsLength - 1].type === 'DISCHARGE'
  }

  return false
}

export async function overwritePatientEvent(newDate, patientEvent) {
  if (newDate && patientEvent?._id) {
    let newEventDate = moment.utc(newDate).toISOString()
    const payload = {
      ...patientEvent,
      date: newEventDate,
    }
    let wasSuccess = await overridePatientEvent(payload)
    if (!wasSuccess) {
      toast.error(
        patientEvent?.type === 'DISCHARGE'
          ? 'Patient has previously been discharged on chosen discharge date'
          : 'Patient has previously been admitted on chosen admission date',
      )
      return false
    }
    return true
  }

  toast.error('Unable to update date or encounter')
  return false
}

// make if doesnt exist OR is unconnected
export async function processPatientEventDate(visit, newDate, type) {
  if (!newDate) {
    toast.error('No date change detected')
    return false
  }
  const isAdmit = type === 'ADMIT'

  let newEventDate = moment.utc(newDate).toISOString()
  if (visit?.patient_id && visit?._id) {
    const payload = {
      charge_id: visit._id,
      patient_id: visit.patient_id,
      service_date_from: visit?.service_date_from,
      date: newEventDate,
      type: type,
    }
    let id = await createNewPatientEvent(payload)
    if (!id) {
      toast.error(`Unable to update ${isAdmit ? 'Admission' : 'Discharge'} Date for encounter`)
      return null
    }
    return id
  }

  toast.error('No charge or patient found')
  return false
}
